import {
  Evento,
  ExcesoVelocidad,
  Geocerca,
  Grupo,
  Movil,
  MovilesCerca,
  PaSuben,
  Recorrido,
  Ruta,
  SesionData,
  Ralenti,
} from "@/interfaces/modelos";
import modalComponent from "@/utils/modalComponent/store";
import { createStore } from "vuex";

const calculateMapSize = () => {
  const width = window.innerWidth;
  let size;

  if (width > 2160) {
    size = "79vh";
  } else if (width > 1440) {
    size = "69vh";
  } else if (width > 1024) {
    size = "59vh";
  } else if (width > 769) {
    size = "49vh";
  } else {
    size = "49vh";
  }

  return size;
};

const modals = {
  rutas: false,
  ModalPrueba: false,
  EdicionActivacion: false,
  Edicion: false,
  Recorrido: false,
  Eventos: false,
  Viajes: false,
  FechasFotos: false,
  AyudaIconos: false,
  ExcesosVelocidad: false,
  FechasConteoVelocidad: false,
  ConteoVelocidad: {
    show: false,
    props: {},
  },
  FechasInformeMultitarifa: false,
  FechasControlViajes: false,
  ConteoViajesPasajeros: {
    show: false,
    props: {},
  },
  FechasPasajerosConductor: false,
  PasajerosConductor: {
    show: false,
    props: {},
  },
  FechasPasajerosHoras: false,
  PasajerosHoras: {
    show: false,
    props: {},
  },
  FechasSubidasContador: false,
};

const initialState: State = {
  is_logged: false,
  userData: {
    nombre: "",
    id_cliente: "",
    tipo_cliente: "",
    estado_cliente: "",
    id_empresa: "",
    validar_ingreso: "",
    cedula: "",
    conteo_ia: "",
  },
  modals,
  mapSize: calculateMapSize(),
  mapRecorridoSize: calculateMapSize(),
  mapEventosSize: calculateMapSize(),
  mapExcesosVelocidadSize: calculateMapSize(),
  mapSubidasContadorSize: calculateMapSize(),
  mapDatosRalentiSize: calculateMapSize(),
  mapRoutes: [],
  routes: [],
  group: null,
  rutasBackup: [],
  geoCercas: [],
  geoCercasActivas: [],
  centerGeocerca: null,
  updateGeocercas: false,
  geoCercaAEditar: null,
  refreshGeoCercas: false,
  tabsActive: [
    {
      id: "Posiciones",
      nombre: "Posiciones",
    },
  ],
  posicionesRecorrido: [],
  selectedPosiciones: [],
  lastSelectedPosicion: undefined,
  isLoadingRecorrido: false,
  shouldCenterMapRecorrido: true,
  vehiculos: [],
  vehiculosCopia: [],
  vehiculosSeleccionados: [],
  vehiculosMovilesCerca: [],
  seleccionBtnMovCerca: true,
  ultimoVehiculoSeleccionado: undefined,
  cargandoVehiculos: false,
  centrarMapa: true,
  eventos: [],
  eventosCopia: [],
  eventosSeleccionados: [],
  ultimoeventoseleccionado: undefined,
  cargandoEventos: false,
  centrarMapaEventos: true,
  currentTab: "Posiciones",
  tabsMounted: {},
  vehiculoParaFoto: null,
  vehiculoParaPasajerosHora: null,
  placaParaFotos: "",
  excesosVelocidad: [],
  excesosVelocidadCopia: [],
  excesosVelocidadSeleccionados: [],
  ultimoExcesoVelocidadSeleccionado: undefined,
  cargandoExcesosVelocidad: false,
  centrarMapaExcesosVelocidad: true,
  geoCercaAGuardar: null,
  dibujarGeocerca: false,
  geocercaEditada: null,
  logout: false,
  pasajerosSuben: [],
  pasajerosSubenCopia: [],
  pasajerosSubenSeleccionados: [],
  ultimoPasajerosSubenSeleccionado: undefined,
  cargandoPasajerosSuben: false,
  centrarMapaPasajerosSuben: true,
  latLngSeleccionado: {
    lat: null,
    lng: null,
  },
  dblClickActivo: false,
  //
  datosRalenti: [],
  cargandoDatosRalenti: false,
  centrarMapaDatosRalenti: true,
  ultimoDatosRalentiSeleccionado: undefined,
  datosRalentiSeleccionados: [],
  datosRalentiCopia: [],
  selectedIcon: 'bus', // Valor inicial
};

export default createStore<State>({
  state: initialState,
  getters: {
    getIsLogged(state: State) {
      return state.is_logged;
    },
    getUserData(state: State) {
      return state.userData;
    },
    getMapSize(state: State) {
      return state.mapSize;
    },
    getMapRecorridoSize(state: State) {
      return state.mapRecorridoSize;
    },
    getModals(state: State) {
      return state.modals;
    },
    getGeoCercas(state: State) {
      return state.geoCercas;
    },
    getGeoCercasActivas(state: State) {
      return state.geoCercasActivas;
    },
    getcenterGeoCerca(state: State) {
      return state.centerGeocerca;
    },
    getUpdateGeoCercas(state: State) {
      return state.updateGeocercas;
    },
    getGeoCercaAEditar(state: State) {
      return state.geoCercaAEditar;
    },
    getRefreshGeoCercas(state: State) {
      return state.refreshGeoCercas;
    },
    getTabsActive(state: State) {
      return state.tabsActive;
    },
  },
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    SET_LOGOUT(state, value) {
      state.logout = value;
    },
    setIsLogged(state, is_logged: boolean) {
      state.is_logged = is_logged;
    },
    setUserData(state, userData: SesionData) {
      state.userData = userData;
    },
    deleteAllVehicles(state) {
      state.is_logged = true;
      setTimeout(() => {
        state = { ...initialState };
      }, 1000);

      state.centrarMapa = true;
      state.vehiculosCopia = [];
      state.vehiculos = [];
      state.vehiculosSeleccionados = [];
      state.vehiculosMovilesCerca = [];
      state.seleccionBtnMovCerca = true;
      state.ultimoVehiculoSeleccionado = undefined;
      state.cargandoVehiculos = false;
      state.shouldCenterMapRecorrido = true;
      state.modals = modals;
      state.tabsActive = [
        {
          id: "Posiciones",
          nombre: "Posiciones",
        },
      ];

      state.centrarMapa = true;
      state.posicionesRecorrido = [];
      state.selectedPosiciones = [];
      state.lastSelectedPosicion = undefined;
      state.isLoadingRecorrido = false;
      state.vehiculoParaFoto = null;
      state.placaParaFotos = "";
    },
    deleteAllPosiciones(state) {
      state.centrarMapa = true;
      state.posicionesRecorrido = [];
      state.selectedPosiciones = [];
      state.lastSelectedPosicion = undefined;
      state.isLoadingRecorrido = false;
      state.placaParaFotos = "";
    },
    deleteAllEventos(state) {
      state.centrarMapaEventos = true;
      state.eventos = [];
      state.eventosCopia = [];
      state.eventosSeleccionados = [];
      state.ultimoeventoseleccionado = undefined;
      state.cargandoEventos = false;
    },
    deleteAllExcesos(state) {
      state.centrarMapaExcesosVelocidad = true;
      state.excesosVelocidad = [];
      state.excesosVelocidadCopia = [];
      state.excesosVelocidadSeleccionados = [];
      state.ultimoExcesoVelocidadSeleccionado = undefined;
      state.cargandoExcesosVelocidad = false;
    },
    deleteAllPasajerosSuben(state) {
      state.centrarMapaPasajerosSuben = true;
      state.pasajerosSuben = [];
      state.pasajerosSubenCopia = [];
      state.pasajerosSubenSeleccionados = [];
      state.ultimoPasajerosSubenSeleccionado = undefined;
      state.cargandoPasajerosSuben = false;
    },
    deleteAllDatosRalenti(state) {
      state.centrarMapaDatosRalenti = true;
      state.datosRalenti = [];
      state.pasajerosSubenCopia = [];
      state.datosRalentiSeleccionados = [];
      state.ultimoDatosRalentiSeleccionado = undefined;
      state.cargandoDatosRalenti = false;
    },
    setMapSize(state, mapSize: string) {
      state.mapSize = mapSize;
    },
    setMapRecorridoSize(state, mapSize: string) {
      state.mapRecorridoSize = mapSize;
    },
    setMapEventosSize(state, mapSize: string) {
      state.mapEventosSize = mapSize;
    },
    setMapExcesosVelocidadSize(state, mapSize: string) {
      state.mapExcesosVelocidadSize = mapSize;
    },
    setMapSubidasContadorSize(state, mapSize: string) {
      state.mapSubidasContadorSize = mapSize;
    },
    setMapDatosRalentiSize(state, mapSize: string) {
      state.mapDatosRalentiSize = mapSize;
    },
    updateModals(state, { id, value }) {
      state.modals[id] = value;
    },
    setRoutes(state, routes) {
      state.routes = routes;
    },
    setRoutesBackup(state, routes) {
      state.rutasBackup = routes;
    },
    addRouteToMap(state, route) {
      state.mapRoutes = [...state.mapRoutes, route];
    },
    removeRouteFromMap(state, routeId) {
      state.mapRoutes = state.mapRoutes.filter((r) => r.gid !== routeId);
    },
    setGroup(state, group: Grupo) {
      state.group = group;
      filtrarRutasMostradasPorGrupo(state);
    },
    updateGeocercas(state, geoCercas: Geocerca[]) {
      state.geoCercas = geoCercas;
    },
    setGeoCercasActivas(state, geoCercasActivas: Geocerca[]) {
      state.geoCercasActivas = geoCercasActivas;
    },
    setCenterGeocerca(state, centerGeocerca: Geocerca | null) {
      state.centerGeocerca = centerGeocerca;
    },
    setUpdateGeocercas(state, updateGeocercas: boolean) {
      state.updateGeocercas = updateGeocercas;
    },
    setGeoCercaAEditar(state, geoCercaAEditar: Geocerca | null) {
      state.geoCercaAEditar = geoCercaAEditar;
    },
    setRefreshGeoCercas(state, refreshGeoCercas: boolean) {
      state.refreshGeoCercas = refreshGeoCercas;
    },
    addTabActive(state, tab: { id: string; nombre: string; props?: unknown }) {
      const index = state.tabsActive.findIndex((t) => t.id === tab.id);
      if (index !== -1) state.tabsActive.splice(index, 1);
      setTimeout(() => {
        state.tabsActive.push(tab);
      }, 0);
    },
    deleteTabActive(state, id: string) {
      state.tabsActive = state.tabsActive.filter((tab) => tab.id !== id);
    },

    //
    setPosiciones(state, posiciones: Recorrido[]): void {
      state.posicionesRecorrido = posiciones;
    },

    selectAllPosiciones(state): void {
      state.selectedPosiciones = state.posicionesRecorrido.map(
        (p: Recorrido) => p.id_posicion
      );
    },

    deselectAllPosiciones(state): void {
      state.selectedPosiciones = [];
    },

    setselectedPosiciones(state, posiciones: number[]) {
      state.selectedPosiciones = posiciones;
    },

    setLoadingRecorrido(state, status: boolean) {
      state.isLoadingRecorrido = status;
    },
    setShouldCenterMapRecorrido(state, value: boolean) {
      state.shouldCenterMapRecorrido = value;
    },
    //

    establecerVehiculos(state, vehiculos: Movil[]): void {
      state.vehiculos = vehiculos;
    },

    establecerVehiculosCopia(state, vehiculos: Movil[]): void {
      state.vehiculosCopia = vehiculos;
    },

    seleccionarTodosLosVehiculos(state: State): void {
      // Utilizamos un Set para manejar ids únicos y evitar duplicados
      const idsYaSeleccionados = new Set(state.vehiculosSeleccionados);

      // Filtramos y agregamos nuevos ids sólo si aún no han sido seleccionados
      for (const movil of state.vehiculosCopia) {
        if (!idsYaSeleccionados.has(movil.id_movil)) {
          idsYaSeleccionados.add(movil.id_movil);
        }
      }

      // Convertimos el Set nuevamente a un array para actualizar el estado
      state.vehiculosSeleccionados = Array.from(idsYaSeleccionados);

      // Siempre será el último elemento del array de vehículos seleccionados,
      // siempre que el array no esté vacío
    const ultimoId =
        state.vehiculosSeleccionados[state.vehiculosSeleccionados.length - 1];
      state.ultimoVehiculoSeleccionado = state.vehiculos.find(
        (m) => m.id_movil === ultimoId
      );
    },

    deseleccionarTodosLosVehiculos(state): void {
      // seleccionar el primer vehiculo de vehiculosCopia
      state.vehiculosSeleccionados = state.vehiculosCopia
        .filter((_, index: number) => index === 0)
        .map((m: Movil) => m.id_movil);
    },

    establecerVehiculosSeleccionados(state, vehiculos: number[]) {
      state.vehiculosSeleccionados = vehiculos;
      state.ultimoVehiculoSeleccionado = state.vehiculos.find(
        (m: Movil) =>
          m.id_movil ===
          state.vehiculosSeleccionados[state.vehiculosSeleccionados.length - 1]
      );
    },

    establecervehiculosMovilesCerca(state, vehiculos: number[]): void {
      state.vehiculosMovilesCerca = vehiculos;
    },

    limpiarVehiculosMovilesCerca(state) {
      state.vehiculosMovilesCerca = []; // Limpia la lista de vehículos cercanos
    },

    establecerCargandoVehiculos(state, status: boolean) {
      state.cargandoVehiculos = status;
    },
    establecerCentrarMapa(state, value: boolean) {
      state.centrarMapa = value;
    },
    establecerSeleccionBtnMovCerca(state, value: boolean) {
      state.seleccionBtnMovCerca = value;
    },

    ///
    establecerEventos(state, eventos: Evento[]): void {
      state.eventos = eventos;
    },

    establecerEventosCopia(state, eventos: Evento[]): void {
      state.eventosCopia = eventos;
    },

    seleccionarTodosLosEventos(state: State): void {
      state.eventosSeleccionados = state.eventos.map(
        (e: Evento) => e.id_posicion
      );
    },

    deseleccionarTodosLosEventos(state): void {
      state.eventosSeleccionados = [];
    },

    establecerEventosSeleccionados(state, eventos: number[]) {
      state.eventosSeleccionados = eventos;
    },

    establecerCargandoEventos(state, status: boolean) {
      state.cargandoEventos = status;
    },

    establecerCentrarMapaEventos(state, value: boolean) {
      state.centrarMapaEventos = value;
    },

    ////
    selectAllRoutes(state) {
      state.routes = state.rutasBackup;
    },

    deselectAllRoutes(state) {
      state.routes = [];
    },

    //
    setCurrentTab(state, tab: string) {
      state.currentTab = tab;
    },

    // otros mutations...
    setTabMounted(state, tabId) {
      state.tabsMounted = { ...state.tabsMounted, [tabId]: true };
    },
    removeTabMounted(state, tabId: string) {
      const { [tabId]: _, ...rest } = state.tabsMounted;
      // const { [tabId]: _, ...rest }: { [key: string]: boolean } =
      //   state.tabsMounted;

      state.tabsMounted = rest;
    },
    // otros mutations...
    setVehiculoParaFoto(state, vehiculo: Movil | null) {
      state.vehiculoParaFoto = vehiculo;
    },
    setVehiculoParaPasajerosHora(state, vehiculo: Movil | null) {
      state.vehiculoParaPasajerosHora = vehiculo;
    },
    setSelectedIcon(state, icon) {
      state.selectedIcon = icon;
    },

    // Fotos recorrido
    setPlacaParaFotos(state, placa: string) {
      state.placaParaFotos = placa;
    },

    // Excesos de velocidad
    establecerExcesosVelocidad(state, excesos: ExcesoVelocidad[]): void {
      state.excesosVelocidad = excesos;
    },

    establecerExcesosVelocidadCopia(state, excesos: ExcesoVelocidad[]): void {
      state.excesosVelocidadCopia = excesos;
    },

    seleccionarTodosLosExcesosVelocidad(state: State): void {
      state.excesosVelocidadSeleccionados = state.excesosVelocidad.map(
        (e: ExcesoVelocidad) => e.id_posicion
      );
    },

    deseleccionarTodosLosExcesosVelocidad(state): void {
      state.excesosVelocidadSeleccionados = [];
    },

    establecerExcesosVelocidadSeleccionados(state, excesos: number[]) {
      state.excesosVelocidadSeleccionados = excesos;
    },

    establecerCargandoExcesosVelocidad(state, status: boolean) {
      state.cargandoExcesosVelocidad = status;
    },

    establecerCentrarMapaExcesosVelocidad(state, value: boolean) {
      state.centrarMapaExcesosVelocidad = value;
    },

    establecergeoCercaAGuardar(state, geocerca: any | null) {
      state.geoCercaAGuardar = geocerca;
    },

    habilitarDibujarGeocerca(state, value: boolean) {
      state.dibujarGeocerca = value;
    },

    establecerGeocercaEditada(state, geocerca: geo | null) {
      state.geocercaEditada = geocerca;
    },

    // Subidas contador
    establecerPasajerosSuben(state, pasajeros: PaSuben[]): void {
      state.pasajerosSuben = pasajeros;
    },

    establecerPasajerosSubenCopia(state, pasajeros: PaSuben[]): void {
      state.pasajerosSubenCopia = pasajeros;
    },

    seleccionarTodosLosPasajerosSuben(state: State): void {
      state.pasajerosSubenSeleccionados = state.pasajerosSuben.map(
        (e: PaSuben) => e.id_contador
      );
    },

    deseleccionarTodosLosPasajerosSuben(state): void {
      state.pasajerosSubenSeleccionados = [];
    },

    establecerPasajerosSubenSeleccionados(state, pasajeros: number[]) {
      state.pasajerosSubenSeleccionados = pasajeros;
    },

    establecerCargandoPasajerosSuben(state, status: boolean) {
      state.cargandoPasajerosSuben = status;
    },

    establecerCentrarMapaPasajerosSuben(state, value: boolean) {
      state.centrarMapaPasajerosSuben = value;
    },

    // Ralenti
    establecerDatosRalenti(state, ralent: Ralenti[]): void {
      state.datosRalenti = ralent;
    },

    establecerDatosRalentiSeleccionados(state, ralenti: number[]) {
      state.datosRalentiSeleccionados = ralenti;
    },

    establecerCargandoDatosRalenti(state, status: boolean) {
      state.cargandoPasajerosSuben = status;
    },

    establecerCentrarMapaDatosRalenti(state, value: boolean) {
      state.centrarMapaPasajerosSuben = value;
    },

    seleccionarTodosLosDatosRalenti(state: State): void {
      state.datosRalentiSeleccionados = state.datosRalenti.map(
        (e: Ralenti) => e.id_posicion
      );
    },

    deseleccionarTodosLosDatosRalenti(state): void {
      state.datosRalentiSeleccionados = [];
    },

    //
    setLatLngSeleccionado(state, { lat, lng }) {
      state.latLngSeleccionado.lat = lat;
      state.latLngSeleccionado.lng = lng;
    },
    setDblClickActivo(state, value) {
      state.dblClickActivo = value;
    },
  },
  actions: {
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    logoutAction({ commit }) {
      commit("SET_LOGOUT", true); // Cambia el estado para indicar que se cerró sesión
    },
    updateSelectedVehicle({ commit }, vehicle) {
      commit("setSelectedVehicle", vehicle);
    },
    updateIsLogged({ commit }, is_logged) {
      commit("setIsLogged", is_logged);
    },
    updateUserData({ commit }, userData) {
      commit("setUserData", userData);
    },
    updateMovil({ commit }, movil: Movil) {
      commit("setMovil", movil);
    },
    updateIdToDelete({ commit }, idToDelete: number) {
      commit("setIdToDelete", idToDelete);
    },
    addModal({ commit }, modal) {
      commit("addModal", modal);
    },
    deleteModal({ commit }, modal) {
      commit("deleteModal", modal);
    },
    deleteAllVehicles({ commit }) {
      commit("deleteAllVehicles");
    },
    deleteAllPosiciones({ commit }) {
      commit("deleteAllPosiciones");
    },
    deleteAllEventos({ commit }) {
      commit("deleteAllEventos");
    },
    deleteAllExcesos({ commit }) {
      commit("deleteAllExcesos");
    },
    deleteAllPasajerosSuben({ commit }) {
      commit("deleteAllPasajerosSuben");
    },
    updateVehiculosMarcados({ commit }, vehiculos: Movil[]) {
      commit("updateVehiculosMarcados", vehiculos);
    },
    updateMapSize({ commit }, mapSize: string) {
      commit("setMapSize", mapSize);
    },
    updateMapRecorridoSize({ commit }, mapSize: string) {
      commit("setMapRecorridoSize", mapSize);
    },
    updateMapEventosSize({ commit }, mapSize: string) {
      commit("setMapEventosSize", mapSize);
    },
    updateMapExcesosVelocidadSize({ commit }, mapSize: string) {
      commit("setMapExcesosVelocidadSize", mapSize);
    },
    updateMapSubidasContadorSize({ commit }, mapSize: string) {
      commit("setMapSubidasContadorSize", mapSize);
    },
    updateMapDatosRalentiSize({ commit }, mapSize: string) {
      commit("setMapDatosRalentiSize", mapSize);
    },
    updateRutasVisible({ commit }, rutasVisible: boolean) {
      commit("updateRutasVisible", rutasVisible);
    },
    updateModals({ commit }, { id, value }) {
      commit("updateModals", { id, value });
    },
    updateRoutes({ commit }, routes) {
      commit("setRoutes", routes);
    },
    updateRoutesBackup({ commit }, routes) {
      commit("setRoutesBackup", routes);
    },
    toggleRouteOnMap({ commit, state }, route) {
      const isOnMap = state.mapRoutes.some((r) => r.gid === route.gid);
      if (isOnMap) {
        commit("removeRouteFromMap", route.gid);
      } else {
        commit("addRouteToMap", route);
      }
    },
    updateGroup({ commit }, group: Grupo) {
      commit("setGroup", group);
    },
    updateCenterCol({ commit }, centerCol: boolean) {
      commit("setCenterCol", centerCol);
    },
    updateLoadingMoviles({ commit }, loadingMoviles: boolean) {
      commit("setLoadingMoviles", loadingMoviles);
    },
    updateCantidadVh({ commit }, cantidadVh: number) {
      commit("setCantidadVh", cantidadVh);
    },
    updateSelectAll({ commit }, selectAll: boolean) {
      commit("setSelectAll", selectAll);
    },
    updateUnselectAll({ commit }, unselectAll: boolean) {
      commit("setUnselectAll", unselectAll);
    },
    updateVhsToDeleteFromMap({ commit }, vhsToDeleteFromMap: Movil[]) {
      commit("setVhsToDeleteFromMap", vhsToDeleteFromMap);
    },
    updateMarketVhToDelete({ commit }, vehicle: Movil) {
      commit("deleteMarketVh", vehicle);
    },
    updateGeocercas({ commit }, geoCercas: Geocerca[]) {
      commit("updateGeocercas", geoCercas);
    },
    updateGeoCercasActivas({ commit }, geoCercasActivas: Geocerca[]) {
      commit("setGeoCercasActivas", geoCercasActivas);
    },
    updateCenterGeocerca({ commit }, centerGeocerca: Geocerca | null) {
      commit("setCenterGeocerca", centerGeocerca);
    },
    updateUpdateGeocercas({ commit }, updateGeocercas: boolean) {
      commit("setUpdateGeocercas", updateGeocercas);
    },
    updateGeoCercaAEditar({ commit }, geoCercaAEditar: Geocerca | null) {
      commit("setGeoCercaAEditar", geoCercaAEditar);
    },
    updateRefreshGeoCercas({ commit }, refreshGeoCercas: boolean) {
      commit("setRefreshGeoCercas", refreshGeoCercas);
    },
    addTabActive({ commit }, tab: string) {
      commit("addTabActive", tab);
    },
    deleteTabActive({ commit }, tab: string) {
      commit("deleteTabActive", tab);
    },
    updateCantidadVhFiltered({ commit }, cantidadVhFiltered: number) {
      commit("updateCantidadVhFiltered", cantidadVhFiltered);
    },
    /////
    selectAllRoutes({ commit }) {
      commit("selectAllRoutes");
    },

    deselectAllRoutes({ commit }) {
      commit("deselectAllRoutes");
    },
    // otros actions...
    updateTabMounted({ commit }, tabId) {
      commit("setTabMounted", tabId);
    },
    updateTabUnmounted({ commit }, tabId) {
      commit("removeTabMounted", tabId);
    },
    actualizarLatLngSeleccionado({ commit }, { lat, lng }) {
      commit("setLatLngSeleccionado", { lat, lng });
    },
    activarDblClickEnMapa({ commit }, value) {
      commit("setDblClickActivo", value);
    },
    // otros actions...

    updateSelectedIcon({ commit }, icon: 'bus') {
      commit('setSelectedIcon', icon);
    },
  },
  modules: { modalComponent },
});

const filtrarRutasMostradasPorGrupo = (state: State) => {
  if (state.group) {
    state.routes = state.rutasBackup.filter(
      (r) => r.id_grupo === state.group?.id_grupo
    );
  } else {
    state.routes = state.rutasBackup;
  }
};

export interface State {
  is_logged: boolean;
  userData: SesionData;
  modals: { [key: string]: boolean | { show: boolean; props: any,  action?: string; } };
  mapSize: string;
  mapRecorridoSize: string;
  mapEventosSize: string;
  mapExcesosVelocidadSize: string;
  mapSubidasContadorSize: string;
  mapDatosRalentiSize: string;
  mapRoutes: Ruta[];
  routes: Ruta[];
  group: Grupo | null;
  rutasBackup: Ruta[];
  geoCercas: Geocerca[];
  geoCercasActivas: Geocerca[];
  centerGeocerca: Geocerca | null;
  updateGeocercas: boolean;
  geoCercaAEditar: Geocerca | null;
  refreshGeoCercas: boolean;
  tabsActive: { id: string; nombre: string; props?: any }[];
  posicionesRecorrido: Recorrido[];
  selectedPosiciones: number[];
  lastSelectedPosicion?: Recorrido;
  isLoadingRecorrido: boolean; // Nuevo estado para controlar la carga
  shouldCenterMapRecorrido: boolean; // Nuevo estado para controlar si el mapa debe centrarse
  vehiculos: Movil[];
  vehiculosCopia: Movil[];
  vehiculosSeleccionados: number[];
  vehiculosMovilesCerca: number[];
  seleccionBtnMovCerca: boolean;
  ultimoVehiculoSeleccionado?: Movil;
  cargandoVehiculos: boolean;
  centrarMapa: boolean;
  eventos: Evento[];
  eventosCopia: Evento[];
  eventosSeleccionados: number[];
  ultimoeventoseleccionado?: Evento;
  cargandoEventos: boolean;
  centrarMapaEventos: boolean;
  currentTab: string;
  tabsMounted: { [key: string]: boolean };
  vehiculoParaFoto: Movil | null;
  vehiculoParaPasajerosHora: Movil | null;
  placaParaFotos: string;

  excesosVelocidad: ExcesoVelocidad[];
  excesosVelocidadCopia: ExcesoVelocidad[];
  excesosVelocidadSeleccionados: number[];
  ultimoExcesoVelocidadSeleccionado?: ExcesoVelocidad;
  cargandoExcesosVelocidad: boolean;
  centrarMapaExcesosVelocidad: boolean;

  //
  geoCercaAGuardar: any | null;
  dibujarGeocerca: boolean;
  geocercaEditada: geo | null;

  //
  logout: boolean;

  //
  pasajerosSuben: PaSuben[];
  pasajerosSubenCopia: PaSuben[];
  pasajerosSubenSeleccionados: number[];
  ultimoPasajerosSubenSeleccionado?: PaSuben;
  cargandoPasajerosSuben: boolean;
  centrarMapaPasajerosSuben: boolean;

  //
  datosRalenti: Ralenti[];
  datosRalentiCopia: PaSuben[];
  datosRalentiSeleccionados: number[];
  ultimoDatosRalentiSeleccionado?: PaSuben;
  cargandoDatosRalenti: boolean;
  centrarMapaDatosRalenti: boolean;
  //

  latLngSeleccionado: {
    lat: null,
    lng: null,
  },
  dblClickActivo: false,
  selectedIcon: 'bus', // Valor inicial
}

interface geo {
  gid: number;
  coords: string;
}

// ////
// store.js

const getDefaultState = () => {
  const modals = {
    rutas: false,
    ModalPrueba: false,
    EdicionActivacion: false,
    Edicion: false,
    Recorrido: false,
    Eventos: false,
    Viajes: false,
    FechasFotos: false,
    AyudaIconos: false,
    ExcesosVelocidad: false,
    FechasConteoVelocidad: false,
    ConteoVelocidad: {
      show: false,
      props: {},
    },
    FechasInformeMultitarifa: false,
    FechasControlViajes: false,
    ConteoViajesPasajeros: {
      show: false,
      props: {},
    },
  };

  return {
    is_logged: false,
    userData: {
      nombre: "",
      id_cliente: "",
      tipo_cliente: "",
      estado_cliente: "",
      id_empresa: "",
      validar_ingreso: "",
      conteo_ia: "",
    },
    modals,
    mapSize: calculateMapSize(),
    mapRecorridoSize: calculateMapSize(),
    mapEventosSize: calculateMapSize(),
    mapExcesosVelocidadSize: calculateMapSize(),
    mapRoutes: [],
    routes: [],
    group: null,
    rutasBackup: [],
    geoCercas: [],
    geoCercasActivas: [],
    centerGeocerca: null,
    updateGeocercas: false,
    geoCercaAEditar: null,
    refreshGeoCercas: false,
    tabsActive: [
      {
        id: "Posiciones",
        nombre: "Posiciones",
      },
    ],
    posicionesRecorrido: [],
    selectedPosiciones: [],
    lastSelectedPosicion: undefined,
    isLoadingRecorrido: false,
    shouldCenterMapRecorrido: true,
    vehiculos: [],
    vehiculosCopia: [],
    vehiculosSeleccionados: [],
    vehiculosMovilesCerca: [],
    seleccionBtnMovCerca: true,
    ultimoVehiculoSeleccionado: undefined,
    cargandoVehiculos: false,
    centrarMapa: true,
    eventos: [],
    eventosCopia: [],
    eventosSeleccionados: [],
    ultimoeventoseleccionado: undefined,
    cargandoEventos: false,
    centrarMapaEventos: true,
    currentTab: "Posiciones",
    tabsMounted: {},
    vehiculoParaFoto: null,
    placaParaFotos: "",
    excesosVelocidad: [],
    excesosVelocidadCopia: [],
    excesosVelocidadSeleccionados: [],
    ultimoExcesoVelocidadSeleccionado: undefined,
    cargandoExcesosVelocidad: false,
    centrarMapaExcesosVelocidad: true,
    geoCercaAGuardar: null,
    dibujarGeocerca: false,
    geocercaEditada: null,
    logout: false,
    pasajerosSuben: [],
    pasajerosSubenCopia: [],
    pasajerosSubenSeleccionados: [],
    ultimoPasajerosSubenSeleccionado: undefined,
    cargandoPasajerosSuben: false,
    centrarMapaPasajerosSuben: true,
    selectedIcon: 'bus', // Valor inicial
  };
};

const state = getDefaultState();
